import React, { Component } from 'react';
import { motion } from 'framer-motion';
import {
  FaTwitter, FaFacebookF, FaYoutube, FaLinkedinIn,
  FaChevronUp, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope,
  FaHandHoldingHeart, FaArrowRight
} from 'react-icons/fa';
import { FaTiktok } from 'react-icons/fa6';
import { Link } from 'react-router-dom';
import AppUrl from '../../restApi/AppUrl';
import IRestClient from '../../restApi/IRestClient';
import footerBg from '../../img/footer.jpeg';

const quickLinks = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About Us' },
  { to: '/allprojects', label: 'Projects' },
  { to: '/allevents', label: 'Upcoming Events' },
  { to: '/allgallery', label: 'Gallery' },
  { to: '/allteam', label: 'Our Team' },
  { to: '/contact', label: 'Contact Us' },
];

class Footer extends Component {
  constructor() {
    super();
    this.state = {
      address: '...',
      number: '...',
      email: '...',
      facebook: '...',
      youtube: '...',
      twitter: '...',
      linkedin: '...',
      tiktok: '...',
      copyright: '...',
      short_description: '...',
      designed_by: '...',
      error: false,
      showBackToTop: false
    };
    this.handleScroll = this.handleScroll.bind(this);
    this.scrollToTop = this.scrollToTop.bind(this);
  }

  componentDidMount() {
    IRestClient.GetRequest(AppUrl.Footer).then(result => {
      if (result == null) {
        this.setState({ error: true });
      } else {
        this.setState({
          address: result[0]['adress'],
          email: result[0]['email'],
          number: result[0]['number'],
          facebook: result[0]['facebook'],
          youtube: result[0]['youtube'],
          twitter: result[0]['twitter'],
          linkedin: result[0]['linkedin'],
          tiktok: result[0]['tiktok'],
          designed_by: result[0]['designed_by'],
          copyright: result[0]['copyright'],
          short_description: result[0]['short_description']
        });
      }
    }).catch(() => {
      this.setState({ error: true });
    });

    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    this.setState({ showBackToTop: window.scrollY > 300 });
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  render() {
    const {
      address, number, email, facebook, youtube, twitter, linkedin, tiktok,
      copyright, short_description, designed_by, showBackToTop, error
    } = this.state;

    if (error) {
      return (
        <footer
          className="relative text-white py-8 text-center text-sm overflow-hidden"
          style={{ background: '#0D1630' }}
        >
          SOYAN - All Rights Reserved
        </footer>
      );
    }

    return (
      <>
        {/* ── mobile bg-attachment fallback ── */}
        <style>{`
          .footer-bg-img {
            background-attachment: fixed;
          }
        `}</style>

        <footer className="relative text-white overflow-hidden">

          {/* ── Background layers ── */}
          <div className="absolute inset-0 pointer-events-none">
            {/* Photo */}
            <div
              className="footer-bg-img absolute inset-0 w-full h-full"
              style={{
                backgroundImage: `url(${footerBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
              }}
            />
            {/* Primary dark overlay */}
            <div
              className="absolute inset-0"
              style={{ background: 'rgba(8, 15, 35, 0.84)' }}
            />
            {/* Warm green tint at very bottom — brand accent */}
            <div
              className="absolute inset-0"
              style={{
                background: 'linear-gradient(to top, rgba(14,56,32,0.30) 0%, transparent 55%)'
              }}
            />
          </div>

          {/* ── Main content ── */}
          <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">

              {/* Col 1 — About */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
              >
                <div className="flex items-center gap-2 mb-4">
                  <div className="w-8 h-8 bg-secondary-600 rounded-lg flex items-center justify-center">
                    <FaHandHoldingHeart className="text-white text-sm" />
                  </div>
                  <h3 className="text-lg font-bold text-white">About SOYAN</h3>
                </div>
                <p className="text-white/65 text-sm leading-relaxed mb-6">
                  {short_description}
                </p>
                {/* Social icons */}
                <div className="flex flex-wrap gap-2.5">
                  {twitter && (
                    <a href={twitter} target="_blank" rel="noopener noreferrer"
                      className="w-9 h-9 rounded-full flex items-center justify-center text-white/70 hover:text-white transition-all duration-300"
                      style={{ background: 'rgba(255,255,255,0.10)', backdropFilter: 'blur(6px)', border: '1px solid rgba(255,255,255,0.15)' }}
                      onMouseEnter={e => e.currentTarget.style.background = 'rgba(46,139,84,0.7)'}
                      onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.10)'}
                    >
                      <FaTwitter className="text-sm" />
                    </a>
                  )}
                  {facebook && (
                    <a href={facebook} target="_blank" rel="noopener noreferrer"
                      className="w-9 h-9 rounded-full flex items-center justify-center text-white/70 hover:text-white transition-all duration-300"
                      style={{ background: 'rgba(255,255,255,0.10)', backdropFilter: 'blur(6px)', border: '1px solid rgba(255,255,255,0.15)' }}
                      onMouseEnter={e => e.currentTarget.style.background = 'rgba(46,139,84,0.7)'}
                      onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.10)'}
                    >
                      <FaFacebookF className="text-sm" />
                    </a>
                  )}
                  {youtube && (
                    <a href={youtube} target="_blank" rel="noopener noreferrer"
                      className="w-9 h-9 rounded-full flex items-center justify-center text-white/70 hover:text-white transition-all duration-300"
                      style={{ background: 'rgba(255,255,255,0.10)', backdropFilter: 'blur(6px)', border: '1px solid rgba(255,255,255,0.15)' }}
                      onMouseEnter={e => e.currentTarget.style.background = 'rgba(46,139,84,0.7)'}
                      onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.10)'}
                    >
                      <FaYoutube className="text-sm" />
                    </a>
                  )}
                  {linkedin && (
                    <a href={linkedin} target="_blank" rel="noopener noreferrer"
                      className="w-9 h-9 rounded-full flex items-center justify-center text-white/70 hover:text-white transition-all duration-300"
                      style={{ background: 'rgba(255,255,255,0.10)', backdropFilter: 'blur(6px)', border: '1px solid rgba(255,255,255,0.15)' }}
                      onMouseEnter={e => e.currentTarget.style.background = 'rgba(46,139,84,0.7)'}
                      onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.10)'}
                    >
                      <FaLinkedinIn className="text-sm" />
                    </a>
                  )}
                  {tiktok && (
                    <a href={tiktok} target="_blank" rel="noopener noreferrer"
                      className="w-9 h-9 rounded-full flex items-center justify-center text-white/70 hover:text-white transition-all duration-300"
                      style={{ background: 'rgba(255,255,255,0.10)', backdropFilter: 'blur(6px)', border: '1px solid rgba(255,255,255,0.15)' }}
                      onMouseEnter={e => e.currentTarget.style.background = 'rgba(46,139,84,0.7)'}
                      onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.10)'}
                    >
                      <FaTiktok className="text-sm" />
                    </a>
                  )}
                </div>
              </motion.div>

              {/* Col 2 — Quick Links */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
              >
                <h3 className="text-lg font-bold text-white mb-5">Quick Links</h3>
                <ul className="flex flex-col gap-2.5">
                  {quickLinks.map(link => (
                    <li key={link.to}>
                      <Link
                        to={link.to}
                        className="flex items-center gap-2 text-white/65 hover:text-secondary-400 text-sm font-medium transition-colors duration-200 group"
                      >
                        <FaArrowRight className="text-xs text-secondary-500 opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex-shrink-0" />
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </motion.div>

              {/* Col 3 — Contact */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <h3 className="text-lg font-bold text-white mb-5">Contact Info</h3>
                <div className="flex flex-col gap-4">
                  {address && (
                    <div className="flex items-start gap-3">
                      <div
                        className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5"
                        style={{ background: 'rgba(255,255,255,0.10)', border: '1px solid rgba(255,255,255,0.12)' }}
                      >
                        <FaMapMarkerAlt className="text-secondary-400 text-xs" />
                      </div>
                      <p className="text-white/65 text-sm leading-relaxed">{address}</p>
                    </div>
                  )}
                  {number && (
                    <div className="flex items-center gap-3">
                      <div
                        className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0"
                        style={{ background: 'rgba(255,255,255,0.10)', border: '1px solid rgba(255,255,255,0.12)' }}
                      >
                        <FaPhoneAlt className="text-secondary-400 text-xs" />
                      </div>
                      <a href={`tel:${number}`} className="text-white/65 hover:text-white text-sm transition-colors duration-200">
                        {number}
                      </a>
                    </div>
                  )}
                  {email && (
                    <div className="flex items-center gap-3">
                      <div
                        className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0"
                        style={{ background: 'rgba(255,255,255,0.10)', border: '1px solid rgba(255,255,255,0.12)' }}
                      >
                        <FaEnvelope className="text-secondary-400 text-xs" />
                      </div>
                      <a href={`mailto:${email}`} className="text-white/65 hover:text-white text-sm transition-colors duration-200 break-all">
                        {email}
                      </a>
                    </div>
                  )}
                </div>
              </motion.div>

              {/* Col 4 — Contact CTA */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.3 }}
              >
                <h3 className="text-lg font-bold text-white mb-5">Get In Touch</h3>
                <p className="text-white/65 text-sm leading-relaxed mb-6">
                  Have questions or want to partner with us? We'd love to hear from you.
                </p>
                <Link
                  to="/contact"
                  className="inline-flex items-center gap-2 text-white font-bold text-sm px-6 py-3 rounded-xl transition-all duration-300 shadow-lg"
                  style={{ background: '#2E8B54' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#237A4B'}
                  onMouseLeave={e => e.currentTarget.style.background = '#2E8B54'}
                >
                  <FaEnvelope />
                  Contact Us
                </Link>
                {/* Donate Now — hidden until payment goes live */}
                {false && (
                  <Link
                    to="/donate"
                    className="inline-flex items-center gap-2 bg-secondary-600 hover:bg-secondary-500 text-white font-bold text-sm px-6 py-3 rounded-xl transition-all duration-300 shadow-lg"
                  >
                    <FaHandHoldingHeart />
                    Donate Now
                  </Link>
                )}
              </motion.div>
            </div>

            {/* ── Divider + copyright ── */}
            <div
              className="pt-6"
              style={{ borderTop: '1px solid rgba(255,255,255,0.12)' }}
            >
              <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
                <p className="text-white/40 text-xs text-center sm:text-left">
                  {copyright || `© ${new Date().getFullYear()} SOYAN. All rights reserved.`}
                </p>
                {designed_by && (
                  <p className="text-white/40 text-xs">
                    Designed by{' '}
                    <span className="text-secondary-400 font-semibold">{designed_by}</span>
                  </p>
                )}
              </div>
            </div>
          </div>
        </footer>

        {/* ── Back to Top ── */}
        {showBackToTop && (
          <motion.button
            className="fixed bottom-8 right-8 w-12 h-12 bg-secondary-600 hover:bg-secondary-500 text-white rounded-full shadow-2xl flex items-center justify-center z-50 transition-colors duration-300"
            onClick={this.scrollToTop}
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0 }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            aria-label="Back to top"
          >
            <FaChevronUp className="text-sm" />
          </motion.button>
        )}
      </>
    );
  }
}

export default Footer;
